import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { Redirect } from 'react-router-dom';

import Spinner from '../../global/Spinner';
import AlbumFolderPurchaseHeader from './AlbumFolderPurchaseHeader';
import ContentWrap from '../../global/ContentWrap';
import AlbumFolderPurchaseIdentityTagSelectionContainer from '../../../containers/purchase/album-folder-purchase/AlbumFolderPurchaseIdentityTagSelectionContainer';
import UpdateAccountIdentityContainer from '../../../apps/consumer/containers/UpdateAccountIdentityContainer';
import AlbumFolderPurchaseUniformTagModalContainer from '../../../containers/purchase/album-folder-purchase/AlbumFolderPurchaseUniformTagModalContainer';
import Button from '../../global/Button';
import { ALBUM_FOLDER_TAG_TYPE } from '../../../constants/album-folder-tags';
import PhotoModal from '../PhotoModal';
import Alert from '../../global/Alert';
import AlbumFolderPurchaseGradeTagModal from './AlbumFolderPurchaseGradeTagModal';
import { getErrorString } from '../../../util/normalize-errors';
import { getIdentitiesForTagSelection } from '../../../util/purchase-album-folder';
import {
  albumFolderSubscriptionRequired,
  isAlbumFolderTagSelectionRequiredForCheckout,
} from '../../../util/album-folder';

class AlbumFolderPurchaseUniformTagSelection extends Component {
  static propTypes = {
    albumFolder: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    tags: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        type: PropTypes.oneOf(Object.keys(ALBUM_FOLDER_TAG_TYPE)),
        uniform_enabled: PropTypes.bool,
        uniform_numbered: PropTypes.bool,
        levels: PropTypes.shape({
          records: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.string,
              name: PropTypes.string,
            }),
          ),
        }),
      }),
    ),
    identities: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        purchased_album_folders: PropTypes.shape({
          records: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.string,
            }),
          ),
        }),
      }),
    ),
    selectedIdentities: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
      }),
    ),
    loadingIdentities: PropTypes.bool,
    loadingAlbumFolder: PropTypes.bool,
    loadingTags: PropTypes.bool,
    openModal: PropTypes.func,
    closeModal: PropTypes.func,
    success: PropTypes.bool,
    loadingCheckout: PropTypes.bool,
    error: PropTypes.string,
    checkout: PropTypes.func.isRequired,
    identityAlbumFolderTagsCreateMutation: PropTypes.func.isRequired,
    identityAlbumFolderTagsDeleteMutation: PropTypes.func.isRequired,
    subscribedAlbumFolderIdentities: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        album_folder: PropTypes.shape({
          id: PropTypes.string,
        }),
        identity: PropTypes.shape({
          id: PropTypes.string,
        }),
      }),
    ),
    history: PropTypes.shape({
      push: PropTypes.func,
    }),
    identitiesWithTags: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        tags: PropTypes.array,
      }),
    ),
    updatedTag: PropTypes.bool,
  };

  state = {
    updatingGrade: false,
    updateGradeError: '',
    tagSelectionWarning: false,
  };

  onGradeTagSelecion = async (identity, gradeTagId) => {
    const {
      identityAlbumFolderTagsCreateMutation,
      identityAlbumFolderTagsDeleteMutation,
    } = this.props;

    const identityTags = get(identity, 'album_folder_tags.records', []);
    const identityGradeTags = identityTags.filter(identityTag => {
      return (
        get(identityTag, 'album_folder_tag.type') ===
        ALBUM_FOLDER_TAG_TYPE.GRADE
      );
    });

    this.setState(() => ({ updatingGrade: true }));

    try {
      const ids = identityGradeTags.map(({ id }) => id);
      if (ids) {
        identityAlbumFolderTagsDeleteMutation(identity.id, ids);
      }

      await identityAlbumFolderTagsCreateMutation({
        identity_id: identity.id,
        album_folder_tags: [
          {
            album_folder_tag_id: gradeTagId,
          },
        ],
      });
    } catch (error) {
      this.setState(() => ({ updateGradeError: getErrorString(error) }));
    } finally {
      this.setState(() => ({ updatingGrade: false }));
    }
  };

  onTagSelectionComplete = disabled => {
    const { checkout } = this.props;

    if (disabled) {
      this.setState(() => ({
        tagSelectionWarning: true,
      }));
      return;
    }

    checkout();
  };

  render() {
    const {
      albumFolder,
      loadingIdentities,
      loadingAlbumFolder,
      loadingTags,
      identities,
      openModal,
      tags,
      success,
      loadingCheckout,
      error,
      closeModal,
      subscribedAlbumFolderIdentities,
      selectedIdentities,
      history,
      identitiesWithTags,
      updatedTag,
    } = this.props;

    const { updatingGrade, updateGradeError, tagSelectionWarning } = this.state;

    if (loadingIdentities || loadingAlbumFolder || loadingTags) {
      return (
        <div className="wrapper-main content-wrap-gray min-h-100vh justify-content-center align-items-center">
          <Spinner />
        </div>
      );
    }

    const filteredIdentities = getIdentitiesForTagSelection({
      identities,
      subscribedAlbumFolderIdentities,
      albumFolder,
      identitiesForPurchase: selectedIdentities,
    });

    const isAlbumFolderTagSelectionRequiredForCheckoutBool = isAlbumFolderTagSelectionRequiredForCheckout(
      albumFolder,
    );

    if (success || get(tags, 'length', 0) === 0) {
      if (isAlbumFolderTagSelectionRequiredForCheckoutBool) {
        return albumFolderSubscriptionRequired(albumFolder) ? (
          <Redirect
            to={`/purchase/album-folder/${albumFolder.id}/purchase-summary`}
          />
        ) : (
          <Redirect to={`/discover/album-folder/${albumFolder.id}/summary`} />
        );
      }

      history.replace(`/purchase/album-folder/${albumFolder.id}/success`);
    }

    const purchasedIdentitiesWithoutTags = filteredIdentities.find(
      identity => get(identity, 'album_folder_tags.records', []).length === 0,
    );

    const continueButtonDisabled =
      (purchasedIdentitiesWithoutTags &&
        isAlbumFolderTagSelectionRequiredForCheckoutBool &&
        !updatedTag &&
        !identitiesWithTags.some(
          identity => get(identity, 'tags.length', 0) > 0,
        )) ||
      loadingCheckout ||
      updatingGrade;

    return (
      <div className="wrapper-main content-wrap-gray min-h-100vh">
        <AlbumFolderPurchaseHeader
          albumFolder={albumFolder}
          openModal={openModal}
        />

        <ContentWrap>
          <h3 className="mb-1">
            {isAlbumFolderTagSelectionRequiredForCheckoutBool
              ? 'Add your sports info'
              : 'You’re almost done!'}
          </h3>
          <p>Select a filter for everyone below to complete your profile.</p>

          {(error || updateGradeError) && (
            <Alert type="danger">{error || updateGradeError}</Alert>
          )}

          {filteredIdentities.map(identity => (
            <AlbumFolderPurchaseIdentityTagSelectionContainer
              identity={identity}
              tags={tags}
              key={identity.id}
              identities={filteredIdentities}
              defaultExpanded
            />
          ))}

          {continueButtonDisabled && (
            <Alert
              type={`${tagSelectionWarning ? 'danger' : 'info'}`}
              className={`mt-3 ${tagSelectionWarning ? 'notice-me' : ''}`}
            >
              To complete registration, please select sports for everyone above
              (tap on the name to expand the filter selection for each person).
            </Alert>
          )}

          <Button
            btnBlock
            className={`mt-2 ${continueButtonDisabled ? 'disabled' : ''}`}
            onClick={() => this.onTagSelectionComplete(continueButtonDisabled)}
          >
            Continue
          </Button>

          {isAlbumFolderTagSelectionRequiredForCheckoutBool && (
            <Button
              btnBlock
              btnStyle="secondary"
              className="mt-1"
              disabled={loadingCheckout || updatingGrade}
              onClick={() => {
                history.replace(
                  `/purchase/album-folder/${albumFolder.id}/purchase-subscription`,
                );
              }}
            >
              Back
            </Button>
          )}
        </ContentWrap>

        <UpdateAccountIdentityContainer
          stringContext={albumFolder}
          requiresSelfieChecklistVerification
        />
        <AlbumFolderPurchaseUniformTagModalContainer
          albumFolder={albumFolder}
        />
        <AlbumFolderPurchaseGradeTagModal
          onSubmit={this.onGradeTagSelecion}
          stringContext={albumFolder}
          closeModal={closeModal}
        />
        <PhotoModal className="identity-selfie-preview" />
      </div>
    );
  }
}

export default AlbumFolderPurchaseUniformTagSelection;
